import account from "./account.json";
import common from "./common.json";
import mining from "./mining.json";
import portfolio from "./portfolio.json";
import sys from "./sys.json";
import wallet from "./wallet.json";

export default {
	...common,
	...sys,
	...mining,
	...wallet,
	...portfolio,
	...account,
};
